var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfServe = function SvgSelfServe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235,
    height: 186,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    clipPath: "url(#self-serve_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14141C",
    strokeOpacity: 0.4,
    d: "M0 0h135.659v142.806H0z",
    transform: "matrix(.8403 .54212 -.8403 .54212 121 12.175)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16161C",
    strokeOpacity: 0.4,
    d: "M0 0h135.66v9.193H0z",
    transform: "matrix(.84028 .54215 0 1 1 89.597)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343449",
    strokeOpacity: 0.2,
    d: "M0 0h142.816v9.193H0z",
    transform: "matrix(.84028 -.54215 0 1 114.992 163.144)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92.913,
    height: 67.593,
    fill: "#14141C",
    rx: 2,
    transform: "scale(1.1839 .77354)rotate(-45 178.664 -41.85)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 92.413,
    height: 67.093,
    x: 0.419,
    stroke: "#FBF9F9",
    strokeOpacity: 0.7,
    strokeWidth: 0.5,
    rx: 1.75,
    transform: "scale(1.1839 .77354)rotate(-45 179.05 -41.772)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 92.913,
    height: 64.194,
    fill: "#14141C",
    rx: 2,
    transform: "scale(1.1839 .77354)rotate(-45 96.08 -7.648)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 92.413,
    height: 63.694,
    x: 0.419,
    stroke: "#FBF9F9",
    strokeOpacity: 0.7,
    strokeWidth: 0.5,
    rx: 1.75,
    transform: "scale(1.1839 .77354)rotate(-45 96.465 -7.57)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 41.792,
    height: 136.202,
    fill: "#14141C",
    rx: 2,
    transform: "scale(1.1839 .77354)rotate(-45 119.91 49.575)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 41.292,
    height: 135.702,
    x: 0.419,
    stroke: "#FBF9F9",
    strokeOpacity: 0.7,
    strokeWidth: 0.5,
    rx: 1.75,
    transform: "scale(1.1839 .77354)rotate(-45 120.295 49.653)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__b)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .273h7.364v45.166H0z",
    transform: "scale(-1.1839 .77354)rotate(45 -100.228 -34.246)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__c)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .273h7.364v41.706H0z",
    transform: "scale(-1.1839 .77354)rotate(45 -85.305 -82.081)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__d)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .273h7.364v45.166H0z",
    transform: "scale(-1.1839 .77354)rotate(45 -90.679 -57.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__e)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .273h7.364v41.706H0z",
    transform: "scale(-1.1839 .77354)rotate(45 -99.63 -47.502)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__f)",
    fillOpacity: 0.14,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .273h7.364v36.863H0z",
    transform: "scale(-1.1839 .77354)rotate(45 -95.927 -72.978)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__g)",
    fillOpacity: 0.4,
    d: "m83.922 60.187-6.584 4.301L95.295 76.22l6.583-4.301z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__h)",
    fillOpacity: 0.4,
    d: "m111.844 36.645-6.584 4.301 22.011 14.381 6.583-4.301z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__i)",
    fillOpacity: 0.4,
    d: "m98.172 48.604-6.584 4.301 19.694 12.868 6.584-4.302z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__j)",
    fillOpacity: 0.4,
    d: "m85.547 50.8-6.584 4.302 24.328 15.896 6.583-4.302z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__k)",
    fillOpacity: 0.4,
    d: "m111.961 47.164-6.584 4.302 13.902 9.083 6.583-4.302z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__l)",
    fillOpacity: 0.2,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .273h7.364v45.166H0z",
    transform: "scale(-1.1839 .77354)rotate(45 -76.373 -91.833)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__m)",
    fillOpacity: 0.2,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .273h7.364v45.166H0z",
    transform: "scale(-1.1839 .77354)rotate(45 -66.823 -114.887)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__n)",
    fillOpacity: 0.2,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M0 .273h7.364v41.706H0z",
    transform: "scale(-1.1839 .77354)rotate(45 -75.776 -105.09)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__o)",
    fillOpacity: 0.4,
    d: "m123.863 34.09-6.583 4.302 17.956 11.732 6.583-4.301z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__p)",
    fillOpacity: 0.4,
    d: "m138.113 22.508-6.583 4.301 19.694 12.868 6.583-4.302z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__q)",
    fillOpacity: 0.4,
    d: "m125.484 24.704-6.583 4.302L143.228 44.9l6.584-4.302z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#A477B2",
    fillOpacity: 0.7,
    d: "m21.492 84.809 10.819-7.069 1.272.832-10.818 7.068zM10.672 77.74l10.818-7.068 1.273.831-10.819 7.069z",
    opacity: 0.99
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__r)",
    fillOpacity: 0.3,
    d: "M0 0h79.398v5.913H0z",
    transform: "scale(1.1839 .77354)rotate(-45 183.445 -53.393)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__s)",
    fillOpacity: 0.4,
    d: "M0 0h18.84v50.68H0z",
    transform: "scale(1.1839 .77354)rotate(-45 183.445 -53.393)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h50.68",
    transform: "scale(1.1839 .77354)rotate(45 -69.219 176.891)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h50.68",
    transform: "scale(1.1839 .77354)rotate(45 -44.851 186.983)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h50.68",
    transform: "scale(1.1839 .77354)rotate(45 -20.485 197.077)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h79.398",
    transform: "scale(-1.1839 -.77354)rotate(-45 -150.883 152.192)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h79.398",
    transform: "scale(-1.1839 -.77354)rotate(-45 -161.08 156.418)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h79.398",
    transform: "scale(-1.1839 -.77354)rotate(-45 -172.293 161.059)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h79.398",
    transform: "scale(-1.1839 -.77354)rotate(-45 -182.492 165.284)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h79.398",
    transform: "scale(-1.1839 -.77354)rotate(-45 -193.706 169.93)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.148,
    d: "M0-.074h79.398",
    transform: "scale(-1.1839 -.77354)rotate(-45 -204.922 174.574)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    d: "m13.852 79.819 24.82-16.217 3.818 2.494-24.82 16.217z",
    opacity: 0.99
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D9D9D9",
    strokeOpacity: 0.3,
    strokeWidth: 0.45,
    d: "M.377 0h29.198v4.111H.377z",
    opacity: 0.99,
    transform: "scale(1.1839 .77354)rotate(-45 148.19 30.316)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#A477B2",
    fillOpacity: 0.66,
    d: "m31.672 91.461 24.82-16.217 3.818 2.495-24.82 16.217zM37.398 95.204l24.82-16.217 3.818 2.495L41.216 97.7zM54.582 106.431l24.82-16.217 3.818 2.495-24.82 16.217zM88.95 128.884l24.819-16.217 3.818 2.495-24.82 16.217z",
    opacity: 0.99
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    d: "m43.129 98.946 24.82-16.216 3.818 2.494-24.82 16.217z",
    opacity: 0.99
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#A477B2",
    fillOpacity: 0.3,
    d: "m48.856 102.689 24.82-16.217 3.817 2.495-24.82 16.217z",
    opacity: 0.99
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    d: "m60.309 110.173 24.82-16.217 3.818 2.495-24.82 16.217z",
    opacity: 0.99
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#A477B2",
    fillOpacity: 0.3,
    d: "m66.04 113.916 24.819-16.217 3.818 2.495-24.82 16.217z",
    opacity: 0.99
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    d: "m71.766 117.658 24.82-16.217 3.818 2.495-24.82 16.217zM77.492 121.4l24.82-16.217 3.818 2.495-24.82 16.217zM83.223 125.142l24.82-16.217 3.818 2.495-24.82 16.217z",
    opacity: 0.99
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#A477B2",
    fillOpacity: 0.3,
    d: "m94.676 132.627 24.82-16.217 3.818 2.495-24.82 16.217z",
    opacity: 0.99
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillOpacity: 0.3,
    d: "m100.402 136.369 24.82-16.217 3.818 2.495-24.82 16.217zM106.129 140.111l24.82-16.217 3.818 2.495-24.82 16.217z",
    opacity: 0.99
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#self-serve_svg__t)",
    fillOpacity: 0.2,
    d: "M0 0h79.398v57.437H0z",
    transform: "scale(1.1839 .77354)rotate(-45 183.445 -53.393)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__b",
    x1: 5.47,
    x2: 5.47,
    y1: 25.151,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__c",
    x1: 5.47,
    x2: 5.47,
    y1: 23.245,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__d",
    x1: 5.47,
    x2: 5.47,
    y1: 25.151,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__e",
    x1: 5.47,
    x2: 5.47,
    y1: 23.245,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__f",
    x1: 5.47,
    x2: 5.47,
    y1: 20.578,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__g",
    x1: 80.557,
    x2: 91.301,
    y1: 62.385,
    y2: 78.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__h",
    x1: 108.479,
    x2: 121.649,
    y1: 38.843,
    y2: 59.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__i",
    x1: 94.807,
    x2: 106.591,
    y1: 50.802,
    y2: 68.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__j",
    x1: 82.182,
    x2: 96.739,
    y1: 52.999,
    y2: 75.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__k",
    x1: 108.596,
    x2: 116.914,
    y1: 49.363,
    y2: 62.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__l",
    x1: 4.019,
    x2: 4.019,
    y1: 0,
    y2: 45.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__m",
    x1: 4.019,
    x2: 4.019,
    y1: 0,
    y2: 45.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__n",
    x1: 4.019,
    x2: 4.019,
    y1: 0,
    y2: 42.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__o",
    x1: 120.498,
    x2: 131.243,
    y1: 36.289,
    y2: 52.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__p",
    x1: 134.748,
    x2: 146.532,
    y1: 24.706,
    y2: 42.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__q",
    x1: 122.119,
    x2: 136.676,
    y1: 26.903,
    y2: 49.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A477B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__r",
    x1: 0,
    x2: 79.398,
    y1: 2.956,
    y2: 2.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46334C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__s",
    x1: 9.629,
    x2: 9.629,
    y1: 0,
    y2: 50.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A477B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "self-serve_svg__t",
    x1: 39.699,
    x2: 39.699,
    y1: 0,
    y2: 57.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A477B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBF9F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "self-serve_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 12.175h234v173H1z"
  })))));
};
export { SvgSelfServe as ReactComponent };
export default __webpack_public_path__ + "static/self-serve.981e4ed9.svg";